<template>
  <div>
    <b-img :src="file" fluid alt="Responsive image"></b-img>
  </div>
</template>

<script>
export default {
  props:{
    file: String,
  },
  // validations:
  data() {
    return {};
  },

  created() {
    this.file = decodeURIComponent(this.$route.query.file);
  },
  mounted() {},
  methods: {}
};
</script>

<style >
</style>
